import React from "react";
import MenuCollapseIcon from "../MenuCollapseIcon/MenuCollapseIcon";
import MenuExpandIcon from "../MenuExpandIcon/MenuExpandIcon";

const UserAvatarIcon = ({ userName, isMenuExpand }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
    <svg
      width="48"
      height="48"
      viewBox="0 0 49 49"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.4" y="1.21484" width="47" height="47" rx="23.5" fill="white" />
      <rect
        x="1.4"
        y="1.21484"
        width="47"
        height="47"
        rx="23.5"
        stroke="#C4C4C4"
      />
      <text
        x="52%"
        y="54%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="18"
        fill='#262aff'
        fontWeight={700}
      >
        {userName}
      </text>
    </svg>
    {!isMenuExpand ? <MenuExpandIcon width={12} height={12}/> : <MenuCollapseIcon width={12} height={12}/>}
  </div>
);

export default UserAvatarIcon;